export default __webpack_public_path__ + "static/media/ArabicaBlend(South).c317f487.png";